<template>
  <div id="answer" class="listStyle">
    <!-- 点击弹出搜索弹框 -->
    <div @click="showSearchPopup = true" class="openPopup" id="goToHere">
      <van-sticky offset-top="2.24rem">
        <div class="location-png">
          <van-image width="13px" height="17px" :src="locationPng"/>
        </div>
        <van-cell
          v-if="valueC !== null && valueC !== ''"
          :title="'当前城市：' + valueP + '/' + valueC"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />
        <van-cell
          v-else-if="valueP !== null && valueP !== '' && valueC === null"
          :title="'当前城市：' + valueP"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />
         <van-cell
          v-else
          title="点击重新定位"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />

      </van-sticky>
    </div>
    <div class="top">
      <!-- 城市切换弹框 -->
      <van-popup
        v-model="showSearchPopup"
        position="top"
        :style="{ height: '100%' }"
      >
        <div class="selectNavS">
          <van-area
            title="城市切换"
            :area-list="areaList"
            :columns-num="3"
            :visible-item-count="13"
            :value="
              valueC !== '' && valueCityCode !== ''
                ? valueCityCode
                : valueProvCode
            "
            @confirm="clickConfirmWord"
            @cancel="clickCancelWord"
          />
        </div>
      </van-popup>

      <!-- 法规层级 -->
      <regulations-hierarchy ref="regulations"></regulations-hierarchy>

      <!-- 搜索框 -->
      <SearchBox
        ref="searchBox"
        @searchKeyWord="searchKeyWord"
        @selectTime="selectTime"
        @clearTime="clearTime"
        placehold="当前区域官方解答查询">
      </SearchBox>
      <!-- 列表组件 -->
      <list-content
        ref="listContent"
        :updateDatas="updateDatas"
        :provinceLists="provinceLists"
        :cityLists="cityLists"
        :globalLists="globalLists"
        :place="place"
        @changeCityFlag="changeCityFlag"
        @changeProvinceFlag="changeProvinceFlag"
        @changeGlobalFlag="changeGlobalFlag"
        :totalLists="totalLists"
        :totalLists1="totalLists1"
        :totalLists2="totalLists2"
      ></list-content>
    </div>

    <div style="height: 0.001rem"></div>
      <!-- 全国 -->
    <div v-if="globalFlag && globalLists.length > 0" class="pageBoxStyleAsk">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
    <!-- 省份 -->
    <div v-if="provinceFlag && provinceLists.length > 0" class="pageBoxStyleAsk">
      <Pagination
        :currentPage="currentPage1"
        :total="total1"
        :totalLists="totalLists1"
        @prevPage="prevPage1"
        @nextPage="nextPage1"
        @jumpToPageSize="jumpToPageSize1"
      ></Pagination>
    </div>
    <!-- 城市 -->
    <div v-if="cityFlag && cityLists.length > 0" class="pageBoxStyleAsk">
      <Pagination
        :currentPage="currentPage2"
        :total="total2"
        :totalLists="totalLists2"
        @prevPage="prevPage2"
        @nextPage="nextPage2"
        @jumpToPageSize="jumpToPageSize2"
      ></Pagination>
    </div>
    <!-- 底部导航 -->
    <tabbar
      ref="tabbar"
      @alertBars="alertBars"
      @alertCengji="alertCengji"
    ></tabbar>
    <van-overlay :showLoding="showLoding"></van-overlay>
    <!-- <div class="bottom-section">发布层级</div> -->
  </div>
</template>

<script>
import Tabbar from "@/components/common/tabbar";
import RegulationsHierarchy from "@/components/common/regulationsHierarchy"; // 法规层级
import SearchBox from "@/components/common/search";
import ListContent from "@/components/common/listContent";
import Vue from "vue";
import Pagination from "@/components/common/pagination"; // 分页
export default {
  data() {
    return {
      showLoding: false,
      searchText: '', // 搜索文本
      stime: '', // 开始时间
      etime: '', // 结束时间
      areaList: {}, // 城市选择
      showSearchPopup: false, // 切换城市弹框
      province: {},
      city: {},
      SearchTimes: 1, // 查询次数
      updateDatas: {}, // 请求所需参数
      provinceLists: [], // 省份数据列表
      globalLists: [], // 全国数据列表
      cityLists: [], // 城市
      place: true, // 显示列表的标记
      total: 0, // 全国总页数
      total1: 0, // 省份总页数
      total2: 0, // 城市总页数
      totalLists: 0, // 全国总条数
      totalLists1: 0, // 省份总条数
      totalLists2: 0, // 城市总条数
      currentPage: 1, // 全国当前页数
      currentPage1: 1, // 省份当前页数
      currentPage2: 1, // 城市当前页数
      cityFlag: false, // 修改城市flag
      provinceFlag: false, //修改省flag
      globalFlag: true,  //修改全国flag
      locationPng: require("../../assets/index/dizhi.png")
    }
  },
  components: {
    Tabbar,
    SearchBox,
    ListContent,
    Pagination,
    RegulationsHierarchy
  },
  computed: {
    valueP() {
      return this.$store.state.commonSearchData.valueP;
    },
    valueC() {
      return this.$store.state.commonSearchData.valueC;
    },
    valueProvCode() {
      return this.$store.state.commonSearchData.valueProvCode;
    },
    valueCityCode() {
      return this.$store.state.commonSearchData.valueCityCode;
    }
  },
  created() {
    this.updateClearData()
    this.getData()
    this.reqGetProvinceAndCity()
  },
  methods: {
    // 点击弹出搜索导航框 法规分类
    alertBars() {
      this.$refs.classification.alertBars();
    },
    // 点击弹出法规层级框
    alertCengji() {
      this.$refs.regulations.alertCengji();
    },
    // 修改城市flag信息
    changeCityFlag() {
      this.cityFlag = true;
      this.provinceFlag = false;
      this.globalFlag = false;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 修改省flag信息
    changeProvinceFlag() {
      this.cityFlag = false;
      this.provinceFlag = true;
      this.globalFlag = false;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 修改全国flag信息
    changeGlobalFlag() {
      this.cityFlag = false;
      this.provinceFlag = false;
      this.globalFlag = true;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 获取/请求地方版默认数据
    getData(stime, etime, text, cityOrTimeChange = false) {
      this.showLoding = true;
      let nodes = Vue.prototype.$baseConfig.code;
      let args = {
        searchtimes: 1, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text:
            this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
            t: "",
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: [
            { p: "000000", c: "000000" },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: "000000",
            },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: this.$store.state.commonSearchData.valueCityCode,
            },
          ],
          tagid: "",
        },
        pager: [
          { pagesize: 10, pageindex: this.currentPage }, // 全国
          { pagesize: 10, pageindex: this.currentPage1 }, // 省级
          { pagesize: 10, pageindex: this.currentPage2 }, // 市级
        ],
        scencs: "answer"
      };
      this.updateDatas = args

      this.$http
        .reqGetLocalLastFiles(args, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.showLoding = false;
              this.globalLists =
                response.tbls[0].items !== null ? response.tbls[0].items : []; // 全国
              this.provinceLists =
                response.tbls[1].items !== null ? response.tbls[1].items : []; // 省份
              this.cityLists =
                response.tbls[2].items !== null ? response.tbls[2].items : []; // 城市
              this.total = Math.ceil(response.tbls[0].total / 10); // 全国
              this.total1 = Math.ceil(response.tbls[1].total / 10); // 省份
              this.total2 = Math.ceil(response.tbls[2].total / 10); // 城市

              this.totalLists = response.tbls[0].total; // 总的条数 全国
              this.totalLists1 = response.tbls[1].total; // 总的条数 省份
              this.totalLists2 = response.tbls[2].total; // 总的条数 城市

              if (cityOrTimeChange) {
                this.currentPage = 1;
                this.currentPage1 = 1;
                this.currentPage2 = 1;
                if (this.totalLists !== 0) {
                  this.$refs.listContent.changeTabsPlace(0);
                } else if (this.totalLists1 !== 0) {
                  this.$refs.listContent.changeTabsPlace(1);
                } else if (this.totalLists2 !== 0) {
                  this.$refs.listContent.changeTabsPlace(2);
                }
              }

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );

              this.place = true;
              this.$store.dispatch("choose/updateLists", this.lists);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },

    // 刷新清除数据
    updateClearData() {
      this.searchText = "";
      this.SearchTimes = 1;
      this.currentPage2 = 1;
      this.stime = "";
      this.etime = "";
      this.searchText = "";
      this.$store.commit(
        "commonSearchData/changeValueProvCode",
        localStorage.getItem("valueProvCode")
      );
      this.$store.commit(
        "commonSearchData/changeValueCityCode",
        localStorage.getItem("valueCityCode")
      );
      this.$store.commit(
        "commonSearchData/changeValueP",
        localStorage.getItem("valueP")
      );
      this.$store.commit(
        "commonSearchData/changeValueC",
        localStorage.getItem("valueC")
      )
    },

    prevPage() {
      // 全国上一页
      if (this.currentPage == 1) return;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    
    // 跳转到多少页
    jumpToPageSize(num) {
      this.currentPage = num;
      this.getData(this.stime, this.etime, this.searchText);
    },
    prevPage1() {
      // 省份上一页
      if (this.currentPage1 == 1) return;
      this.currentPage = 1;
      this.currentPage2 = 1;
      this.currentPage1--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    nextPage1() {
      // 下一页
      if (this.currentPage1 == this.total1) return;
      this.currentPage = 1;
      this.currentPage2 = 1;
      this.currentPage1++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    jumpToPageSize1(num) {
      // 跳转到多少页
      this.currentPage1 = num;
      this.getData(this.stime, this.etime, this.searchText);
    },
    prevPage2() {
      // 城市上一页
      if (this.currentPage2 == 1) return;
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    nextPage2() {
      // 下一页
      if (this.currentPage2 == this.total2) return;
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.stime, this.etime, this.searchText);
    },
    jumpToPageSize2(num) {
      // 跳转到多少页
      this.currentPage2 = num;
      this.getData(this.stime, this.etime, this.searchText);
    },
    // 清除时间和搜索框的内容
    clearMsg() {
      this.$refs.searchBox.clearMsg();
    },
    // 点击城市选择的确定按钮
    clickConfirmWord(data) {
      if (data[0] != undefined) {
        if (this.changeActivePlace === 0) {
          // 判断显示分页
          this.cityFlag = true;
          this.provinceFlag = false;
          this.globalFlag = false;
        } else if (this.changeActivePlace === 1) {
          this.cityFlag = false;
          this.provinceFlag = true;
          this.globalFlag = false;
        } else if (this.changeActivePlace === 2) {
          this.cityFlag = false;
          this.provinceFlag = false;
          this.globalFlag = true;
        }

        this.SearchTimes = 1;
        this.province = {};
        this.city = {};
        this.clearProOrCityMsg();
        this.tagid = "";
        this.clearMsg();
        this.stime = "";
        this.etime = "";
        this.searchText = "";
        this.showSearchPopup = false;
        this.province = data[0];
        this.$store.commit("commonSearchData/changeValueP", this.province.name);
        this.$store.commit(
          "commonSearchData/changeValueProvCode",
          this.province.code
        );

        if (data[1] !== undefined && data[2] === undefined) {
          this.city = data[1];
          this.$store.commit("commonSearchData/changeValueC", this.city.name);
          this.$store.commit(
            "commonSearchData/changeValueCityCode",
            this.city.code
          );
        }

        if (data[2] !== undefined) {
          this.city = data[2];
          this.$store.commit("commonSearchData/changeValueC", this.city.name);
          this.$store.commit(
            "commonSearchData/changeValueCityCode",
            this.city.code
          );
        }

        // this.alertBars1();
        this.backStatus()
        this.$refs.listContent.toggle([]);
        this.getData(this.stime, this.etime, this.searchText, true);
      } else {
        this.showSearchPopup = false;
      }
    },
    // 清除数据
    clearProOrCityMsg() {
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
    },
     // 恢复选择的状态
    backStatus() {
      this.$store.commit("choose/setFlag1", false);
    },
    // 点击城市选择的取消按钮
    clickCancelWord() {
      this.showSearchPopup = false;
    },
    // 搜索按钮
    searchKeyWord(keyword) {
      this.SearchTimes = 1;
      //this.isFilter = false;
      this.searchText = keyword;
      this.currentPage = 1;
      this.backStatus();
      this.getData(this.stime, this.etime, this.searchText, true);
      this.$refs.listContent.toggle([]);
    },
    // 选择时间
    selectTime(time) {
      this.SearchTimes = 1;
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.getData(this.stime, this.etime, this.searchText, true);
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      this.SearchTimes = 1;
      this.stime = '';
      this.etime = '';
      this.currentPage = 1;
      this.getData(this.stime, this.etime, this.searchText, true);
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 获取省市的数据
    reqGetProvinceAndCity() {
      this.$http
        .reqGetProvinceAndCity()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              let provinceAndCitylists = {
                province_list: {},
                city_list: {
                  110100: "北京",
                  120100: "天津",
                  310100: "上海",
                  500100: "重庆",
                },
                county_list: {},
              };
              res.datas.map((item) => {
                provinceAndCitylists.province_list[item.id] = item.label;
                if (item.id === "110000") {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "120000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "310000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "500000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (
                  item.id !== "110000" &&
                  item.id !== "120000" &&
                  item.id !== "310000" &&
                  item.id !== "500000" &&
                  item.children &&
                  item.children.length > 0
                ) {
                  item.children.map((item) => {
                    provinceAndCitylists.city_list[item.id] = item.label;
                  });
                }
              });
              this.areaList = provinceAndCitylists;
              this.$store.dispatch(
                "commonSearchData/updateProvinceAndCity",
                this.areaList
              );
            }
          }
        })
        .catch((err) => {
          console.log("获取城市数据失败", err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
#answer {
  overflow-y: auto;
  height:calc(100vh - 110px);
  // .top {
  //   flex: 1;
  //   margin-bottom: 70px;
  // }
  .selectNavS {
    padding: 20px 20px 20px;
  }
  .pageBoxStyleAsk {
    width: 100%;
    position: fixed;
    bottom: 2px;
    left: 0;
    font-size: 0.37333rem;
    flex: 0 0 50px;
    background-color: #fff;
  }

  /deep/.van-sticky {
    display: flex;
    align-items: center;
    background-color: white;
    .location-png {
      margin: 0 0px 0 18px;
    }
    .van-cell {
     padding-left: 5px;
    }
  }
}
</style>

